import { apiUpdatePassword } from '../../../../../../common/api/email-identity'

const sendPassword = (id, password) => ({
  requestPrefix: 'FSU_PASSWORD_REQUIRED:SEND_PASSWORD',
  request: () => apiUpdatePassword(id, { password: password })
})

export { sendPassword }
